import { render, staticRenderFns } from "./ItemDetails_Action.vue?vue&type=template&id=9e3b5186&"
import script from "./ItemDetails_Action.vue?vue&type=script&lang=js&"
export * from "./ItemDetails_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports